import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields, fa } from "app/main/std";
import { omit } from "keautils";
import { DatosFacturacion } from "./types";
import { DireccionComponent } from "app/features/componentes/direccion/direccion";
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
export const DireccionFacturacionComponent = obtenerComponenteDireccionColonia<DatosFacturacion>("IdDatosFacturacionColonia", "Direccion", "Dirección de facturación");



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/direccionfacturacion.tsx